export const BASE_URL = "https://alwaysandforevery.com/new/";